import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-tab",
  templateUrl: "./tab.component.html",
  styleUrls: ["./tab.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class TabComponent {
  @Input() public label = "";
  @Input() public active = false;
}
